export default "__VITE_ASSET__B00UrFH$__"